import { ensure } from 'components/sharpr/ensure/ensure';

/**
 * Service for saving recent and named searches
 */
export class SavedSearchesService {
	/**
	 * Create a new instance
	 * @param {ApiService} Api  The Api service instance
	 * @param {$location} $location
	 */
	constructor(Api, $location, FilterMessage) {
		'ngInject';
		/**
		 * For saving recent searches
		 * @type {ApiService}
		 */
		this.Api = Api;
		/**
		 * For deciding the value of the "page" column
		 * @type {$location}
		 */
		this.$location = $location;

		this.FilterMessage = FilterMessage;

		this.recentByPage = { posts: [], newsroom: [], multihub: [] };
		this.namedByPage = { posts: [], newsroom: [], multihub: [] };
		this.recentCallback = () => {};
		this.namedCallback = () => {};
	}

	/**
	 * Get the most recent searches
	 * @returns {Promise}
	 */
	onRecent(callback) {
		this.recentCallback = callback;
		let page = this.getPage();
		this.Api.get('/saved_searches/recent', { page }).then(recent => {
			this.recentByPage[page] = recent;
			this.recentCallback(recent);
		});
	}

	/**
	 * Get the named searches in alphabetical order
	 * @returns {Promise}
	 */
	onNamed(callback) {
		this.namedCallback = callback;
		let page = this.getPage();
		return this.Api.get('/saved_searches/named', { page }).then(named => {
			this.namedByPage[page] = named;
			this.namedCallback(named);
		});
	}

	/**
	 * Save a recent search
	 * @param {Object} FineTuner  The FineTunePosts service
	 */
	saveRecent(FineTuner) {
		let criteria = {
			label: this.FilterMessage.asText(FineTuner),
			hubs: FineTuner.hubs,
			search: FineTuner.search,
		};
		let page = this.getPage();
		let recent = { page, criteria };
		this.Api.post('/saved_searches', recent).then(() => {
			if (!this.recentByPage[page]) {
				this.recentByPage[page] = [];
			}
			this.recentByPage[page].unshift(recent);
			this.uniqifyRecent(page);
			this.recentCallback(this.recentByPage[page]);
		});
	}

	/**
	 *
	 * @param {String} page  The value for the page column (posts|newsroom|multihub)
	 */
	uniqifyRecent(page) {
		const seen = [];
		this.recentByPage[page] = ensure.array(this.recentByPage[page]).filter(recent => {
			if (seen.indexOf(recent.criteria.label) > -1) {
				return false;
			}
			seen.push(recent.criteria.label);
			return true;
		});
	}

	/**
	 * Save a search with the given name
	 * @param {FineTunePostsService} FineTuner  The service to use
	 * @param {String} name  The text name of the search
	 */
	saveNamed(FineTuner, name) {
		let page = this.getPage();
		let named = {
			page,
			name,
			criteria: {
				label: this.FilterMessage.asText(FineTuner),
				hubs: FineTuner.hubs,
				search: FineTuner.search,
			},
		};
		this.Api.post('/saved_searches', named).then(() => {
			this.namedByPage[page].unshift(named);
			this.namedCallback(this.namedByPage[page]);
		});
	}

	/**
	 * Get the value of the page object by looking at the URL
	 * @returns {String|undefined}
	 */
	getPage() {
		let path = this.$location.path();
		if (path.match(/^\/newsroom\/screens\/\d+$/)) {
			return 'newsroom';
		} else if (path === '/multi/posts') {
			return 'multihub';
		} else if (path === '/preferences/auto_emails') {
			return 'auto_emails';
		} else if (path.match(/^\/posts\/pick$/)) {
			return 'post_picker';
		}
		return 'posts';
	}
}
